<template>
    <div>
        <div class="container">
            <div class="form-group">
                <label class="col-md-2 col-sm-3 col-xs-12 control-label">First Name</label>
                <div class="col-md-10 col-sm-9 col-xs-12">

                    <input type="text" class="form-control" value="Rebecca">
                </div>
            </div>
        </div>

        <div class="container py-4">
            <h2 class="mb-4">Settings</h2>
            <router-link :to="{name: 'settingCreate'}" class="btn btn-outline-success btn-sm mb-3">New setting
            </router-link>
            <div class="card">
                <div class="card-body">
                    <vue-good-table
                            :columns="columns"
                            :isLoading.sync="isLoading"
                            :pagination-options="{enabled: true}"
                            :rows="table.rows"
                            :totalRows="table.totalRecords"
                            :sort-options="{
                            enabled: false
                          }"
                            @on-column-filter="onColumnFilter"
                            @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            mode="remote"
                            styleClass="table table-hover">
                        <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'option'">
                    <router-link
                            :to="{name: 'settingUpdate', params: {id: props.row.id}}">{{props.row.option}}</router-link>
                </span>
                            <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                        </template>
                    </vue-good-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table';
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'settingIndex',
        data() {
            return {
                isLoading: false,
                columns: [
                    {
                        label: 'Option',
                        field: 'option',
                    },
                    {
                        label: 'Value',
                        field: 'value',
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: '',
                        type: '',
                    },
                    page: 1,
                    perPage: 10
                }
            };
        },
        computed: mapGetters({
                table: 'TABLE'
            }
        ),
        components: {
            VueGoodTable,
        },
        mounted() {
            this.loadItems()
        },
        methods: {
            ...mapActions({
                    loadItems: 'GET_SETTINGS',
                }
            ),
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            }
        }
    }
</script>
<style>
    .vgt-wrap__footer {
        color: #ffffff;
        padding: 0.5em !important;
        border: none !important;
        border-top: 1px solid #dcdfe6 !important;
        background: #ffffff !important;
    }
</style>
